import { render, staticRenderFns } from "./addDept.vue?vue&type=template&id=62bd12a1&scoped=true"
import script from "./addDept.vue?vue&type=script&lang=js"
export * from "./addDept.vue?vue&type=script&lang=js"
import style0 from "./addDept.vue?vue&type=style&index=0&id=62bd12a1&prod&lang=less"
import style1 from "./addDept.vue?vue&type=style&index=1&id=62bd12a1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bd12a1",
  null
  
)

export default component.exports